$(document).ready(function() {

	$('body').on('click', '.header__menu-icon, .header__close', event => {
		$('body').toggleClass('menu-open');
	});
	
	$( window ).on( 'hashchange', function( e ) {
	    remove_hash_from_url();
	});
	
	function remove_hash_from_url(){
	    var uri = window.location.toString();
	    if (uri.indexOf("#") > 0) {
		    
		    let hash = window.location.hash;
		    console.log(hash);
		    const $target = $(hash);
			var clean_uri = uri.substring(0, uri.indexOf("#"));
	        window.history.replaceState({}, document.title, clean_uri);
	        $('html, body').animate({scrollTop: 0}, {duration: 0});
	        
	        if ($target.length === 0) return;
	        
	        setTimeout(function(){
		        $('html, body').stop().animate({scrollTop: $target.offset().top}, {duration: 500});
				$('body').removeClass('menu-open');
	        }, 250);
	        
	    }
	}
	
	remove_hash_from_url();
	

/*
	$('.header__links a').on('click', function(event) {
		event.preventDefault();
		const href = $(this).attr('href');
		const $target = $(href);
		if ($target.length === 0) return;
		$('html, body').animate({scrollTop: $target.offset().top}, {duration: 500});
		$('body').removeClass('menu-open');
	});
	
	$('body').on('click', '[data-scroll]', function(event) {
		event.preventDefault();
		const href = $(this).attr('href');
		const $target = $(href);
		if ($target.length === 0) return;
		$('html, body').animate({scrollTop: $target.offset().top}, {duration: 500});
		$('body').removeClass('menu-open');
	});
*/

});